<template>
  <div>
    <el-dialog
      title="证件上传"
      :visible.sync="dialogVisible"
      width="699px"
      :before-close="handleClose"
    >
      <div class="form">
        <div class="form-item" v-for="(item, index) in list">
          <div>
            <span class="flex-grow-0" style="margin-right: 20px">
            <s-dict :value="item.name" code="certificate_type"></s-dict>
            <span style="width: 20px; color: red">
              <span v-if="item.status === 1">(必填)</span>
            </span>:
              <span v-if="item.positionFile !== null || item.positionFile !== '' || item.positionFile !== undefined">
                <a @click="downloadPapers(item)" style="color: #0b86de">下载原文件</a>
                <span>上传过的文件可以下载,重新上传会覆盖之前内容</span>
              </span>
          </span>
          </div>

          <div @click="getIndex(index)" style="margin-top: 5px;">
          <el-upload
            ref="upload"
            :action="baseURL"
            name="file"
            :data="{folder:'image'}"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <div class="uploadbtn flex-center"
              size="small"
              type="primary">
              <div v-if="list[index].positionFile">
                {{list[index].positionFile.fileName}}
              </div>
              <div v-else>
                <img src="@/assets/images/upload.png" alt="" />
                <span>上传</span>
              </div>
            </div>
          </el-upload>
            </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" >取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import {getAction,postAction,downloadFile} from "@/api/manage"
  import {SEEKER_INFO} from "@/store/mutation-types"
  import Vue from "vue";

export default {
  data() {
    return {
      dialogVisible: false,
      index: "",
      list: [],
      path: [],
      fileList: {},  //证件信息
      paramList: [],
      positionId: "",
      type: 0,//0证件附件/1其他附件
      url:{
          certificateName:'/home/getCertificateName',
          add: '/home/add',
          getPath: '/home/getPath',
          downloadFile: '/home/downloadFile',
      },
      imageUrl:process.env.VUE_APP_IMAGE_URL,
      baseURL: process.env.VUE_APP_UPLOAD
    };
  },
  props: {},
  created() {
    this.seeker = Vue.ls.get(SEEKER_INFO)
  },
  methods: {
    open(id) {
        let that = this
        this.positionId = id
        getAction(that.url.certificateName, {positionId : id,type: this.type}).then((res) => {
            if (res.success) {
                that.list = res.result
                //防止上传证件为空引起的异常
                if (that.list.length === 0) {
                  that.$parent.updateStatus()
                  this.$emit("ok")
                  this.$message.warning("暂无需要上传的证件")
                  this.handleClose()
                  return
              }
            }
        })
        this.dialogVisible = true;
    },
    handleClose() {
      this.list = [];
      this.$emit("ok")
      this.dialogVisible = false;
    },
    handleAvatarSuccess(e, file) {
      let path = e.result
      let index = this.index
      this.list[index].positionFile = {path: path, positionId: this.positionId, seekerId: this.seeker.id, name: this.list[index].name, fileName: file.name,type: this.type, status: this.list[index].status}
      // this.paramList.push({path: path, positionId: this.positionId, seekerId: this.seeker.id, name: this.list[index].name, fileName: file.name,type: this.type})
    },
    onSubmit() {
      // for (let i = 0; i < this.list.length; i++) {
      //   if (!this.list[i].positionFile) {
      //     this.$message.warning("请上传所有证件！" )
      //     return
      //   }
      // }
      //根据状态来判断是否必须上传
      for (let i = 0; i < this.list.length; i++) {
        if ((this.list[i].status == 1) && (this.list[i].positionFile == null)) {
          this.$message.warning("请上传必须上传的证件！")
          return
        }
      }
      postAction(this.url.add, this.list).then((res) =>{
        if (res.success) {
          this.$parent.onSubmit(1)
          this.handleClose()
        } else {
          this.$message.error(res.message)
          // this.handleClose()
        }
      })
    },
    //下载查看附件
    downloadPapers(item) {
      //查询文件名称和文件路径
      // await getAction (this.url.getPath, {seekerId: this.seeker.id, positionId: item.positionId, name: item.name, type : 0}).then((res) => {
      //  if (res.success) {
      //    this.fileList = res.result
      //  }
      // })
      if (item.positionFile === null) {
        this.$message.warning("暂无文件下载")
        return
      } else {
        this.fileList = item.positionFile.path
      }
      if (this.fileList === null || this.fileList === undefined || this.fileList === "") {
       this.$message.warning("暂无文件下载")
       return
      }
      let paths = this.fileList
      let suffix = paths.split(".")[1]
      let fileNames = this.fileList.fileName
      downloadFile(this.url.downloadFile, fileNames + "." + suffix, {"fileName": paths, "folder": "file"})
    },
    beforeAvatarUpload() {},
    getIndex(index) {
      this.index = index
    }
  },
};
</script>

<style lang="less">
.uploadbtn {
  width: 472px;
  height: 52px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #2752b1;
  text-align: center;
  color: #2752b1;
  padding: 0px;
  img {
    width: 30px;
  }
}
.form-item {
  margin-bottom: 20px;
}
</style>
